import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import ProResponse from '../../types/ProResponse';
import styles from './PaymentForm.module.scss';

type Props = {
  errors: ProResponse['errors'];
};

export default function ErrorText({ errors }: Props) {
  const firstMessage = typeof errors === 'object' && errors.base?.[0] ? errors.base[0] : undefined;

  return (
    <div className={styles.error}>
      <Typography color="error" variant="text200">
        {firstMessage ? (
          firstMessage // this is already localized
        ) : (
          <FormattedMessage defaultMessage="There was an error processing your payment. Please contact support." />
        )}
      </Typography>
    </div>
  );
}
